<template>
  <v-menu
    min-width="350"
    bottom
    v-model="show"
    left
    offset-y
    origin="top right"
    transition="scale-transition"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        icon
        color="primary"
        min-width="0"
        text
        v-bind="attrs"
        @click.native="scrollToElement(attrs)"
        v-on="on"
      >
        <v-icon>mdi-chat</v-icon>
        <v-badge color="primary" v-if="unreadMessages > 0" overlap bordered>
          <template v-slot:badge>
            <span>{{ unreadMessages }}</span>
          </template>
        </v-badge>
      </v-btn>
    </template>
    <div class="container chat" v-on:click.stop>
      <v-list :tile="false" nav class="chat-container" v-on:click.stop>
        <div class="chat-header">
          <v-btn
            class="v-btn--icon"
            v-on:click="changeNotifyStatus"
            text
            min-width="0"
          >
            <v-icon color="error" v-if="ifChatNotify === 0"
              >mdi-volume-mute</v-icon
            >
            <v-icon color="success" v-else>mdi-volume-high</v-icon>
          </v-btn>
          <span v-if="ifChatNotify === 0">{{
            $t("notification_disabled")
          }}</span>
          <span v-else>{{ $t("notification_enabled") }}</span>
          <v-btn
            style="float: right"
            class="v-btn--icon"
            v-on:click="show = false"
            text
            min-width="0"
          >
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="chat-list-container">
          <div class="chat-list">
            <div
              v-for="message in listMessages"
              :key="message.id"
              class="row badge-mini-list chat-row"
              v-bind:class="[message.me ? 'right-chat' : 'left-chat']"
            >
              <div class="badge-mini-container">
                <img :src="message.senderImage" alt="avatar" />
              </div>
              <div class="text">
                <span class="font-weight-medium">{{ message.senderName }}</span>

                <br />
                <small>{{ message.message }}</small> <br />
                <small
                  class="dateTime"
                  v-if="
                    new Date().toDateString() !==
                    new Date(message.dateTime).toDateString()
                  "
                  >{{ new Date(message.dateTime).toLocaleDateString() }} -
                  {{ new Date(message.dateTime).toLocaleTimeString() }} </small
                ><small class="dateTime" v-else>
                  {{ new Date(message.dateTime).toLocaleTimeString() }}
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="chat-footer">
          <form @submit.prevent="sendMessage">
            <div class="md-field md-theme-default chat-text">
              <v-text-field
                v-model="textMessage"
                type="text"
                :placeholder="$t('write_your_message_here')"
                class="md-input"
              />
            </div>
            <v-btn
              text
              class="ma-2 chat-send v-btn--icon"
              min-width="0"
              type="submit"
            >
              <v-icon color="success">mdi-send</v-icon>
            </v-btn>
          </form>
        </div>
      </v-list>
    </div>
  </v-menu>
</template>

<script>
export default {
  name: "chat",

  props: {
    newMessage: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      show: false,
      lastRead: null,
      textMessage: "",
      unreadMessages: 0,
      ifChatNotify: false,
      listMessages: [],
      scrollbarSettings: {
        wheelPropagation: false,
        suppressScrollX: true,
      },
    };
  },
  methods: {
    sendMessage() {
      let _ = this;
      let message = _._data.textMessage;
      _._data.textMessage = "";
      this.chiamataAxios("POST", "/auth/notify/sendNotify", {
        body: {
          type: "chat",
          msg: message,
        },
      }).then((response) => {
        _.refreshMessage();
      });
    },
    changeNotifyStatus() {
      let _ = this;
      this.chiamataAxios("POST", "/auth/notify/switchNotifyChat").then(
        (response) => {
          _.ifChatNotify = response.data.newMode;
        }
      );
    },
    scrollToBottom() {
      setTimeout(function () {
        let chatScroll = document.querySelector(".chat-list");
        if (chatScroll) {
          chatScroll.scrollTop = Math.floor(chatScroll.scrollHeight);
        }
      }, 500);
    },
    scrollToElement(elem) {
      let _ = this;

      if (elem && elem["aria-expanded"] == "true") {
        _.chiamataAxios("POST", "/auth/notify/setReadChat").then((response) => {
          _.lastRead = response.data.lastRead;
          _.unreadMessages = response.data.unreadMessages;
          _.scrollToBottom();
        });
      }
    },
    refreshMessage() {
      let _ = this;
      this.chiamataAxios("GET", "/auth/notify/lastChatMsg").then((response) => {
        _.lastRead = response.data.lastRead;
        _.ifChatNotify = response.data.ifChatNotify;
        _.unreadMessages = response.data.unread;
        _.listMessages = response.data.message;
        _.scrollToBottom();
      });
    },
  },

  mounted() {
    this.refreshMessage();
  },
  watch: {
    newMessage: function (value) {
      if (value) this.refreshMessage();
    },
  },
};
</script>
<style lang="scss" scoped>
.chat {
  overflow: hidden;
  background-color: white;
}
.chat-container {
  width: 100%;
  max-width: 600px;
}
.chat-list-container {
  height: 400px;
  overflow: hidden;
}
.chat-message-container {
  padding: 10px;
}

.chat-header {
  text-align: center;
  line-height: 40px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(180, 180, 180, 0.3);
}

.chat-footer {
  border-top: 1px solid rgba(180, 180, 180, 0.3);
}

.chat-list {
  height: 100%;
  padding: 0px;
  overflow-y: auto;
}
.badge-mini-list {
  width: 100%;
  margin-top: 10px;
}
.left-chat {
  .badge-mini-container {
    position: relative;
    left: 10px;
    float: left;
    width: 50px;
    height: 50px;
    img {
      width: 30px;
      height: 30px;
      border-radius: 30px;
      margin: 10px;
    }
  }
  .text {
    position: relative;
    right: 0px;
    width: calc(100% - 60px);
    top: 5px;
    float: right;
    left: 10px;
    line-height: 20px;
    margin: 0px 0px;
    height: max-content;
  }
}
.right-chat {
  .badge-mini-container {
    position: absolute;
    right: 0px;
    float: right;
    width: 50px;
    height: 50px;
    img {
      width: 30px;
      height: 30px;
      border-radius: 30px;
      margin: 10px;
    }
  }
  .text {
    position: relative;
    text-align: right;
    float: left;
    left: 10px;
    width: calc(100% - 60px);
    top: 5px;
    line-height: 20px;
    margin: 0px 0px;
    height: max-content;
  }
}
.chat-text {
  left: 20px;
  width: calc(100% - 90px);
  position: absolute;
}
.chat-send {
  width: 50px;

  left: calc(100% - 55px);
  margin: 0px;
}
.chat-row {
  position: relative;
}
.dateTime {
  font-size: 10px;
  color: #9e9e9e;
}
</style>
